export default {
  'ec.system.name': 'Harbin New Area and Free Trade Zone comprehensive service platform for Russia',
  'ec.system.slogan': '',
  'ec.system.copyright': '',
}
